import { useQuery } from '@tanstack/react-query';

import {
  AudienceChannelSourceFilters,
  AudienceChannelSourceType,
} from '@/features/broadcasters/types';
import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { PaginatedResponse, ParamsWithPagination } from '@/types/api';

import { audienceChannelSourcesQueryKeys } from './query-keys';

export async function getAudienceChannelSourcesList(
  params?: ParamsWithPagination<AudienceChannelSourceFilters>
): Promise<PaginatedResponse<AudienceChannelSourceType>> {
  return mediaManagerClient.get('/api/v1/audience_channel_sources', {
    params: {
      deleted_at__isnull: true,
      limit: params?.limit,
      offset: params?.offset,
      search: params?.search,
      order_by: params?.order_by,
      id__in: params?.idIn?.join(','),
      scope__in: params?.scopeIn,
      media_type__in: params?.mediaTypeIn,
      provider__in: params?.providerIn?.join(','),
      country__in: params?.countryIn,
      region__in: params?.regionIn,
    },
  });
}

type QueryFnType = typeof getAudienceChannelSourcesList;

interface UseGetAudienceChannelSourcesListParams {
  config?: QueryConfig<QueryFnType>;
  params?: ParamsWithPagination<AudienceChannelSourceFilters>;
}

export function useGetAudienceChannelSourcesList({
  config,
  params,
}: UseGetAudienceChannelSourcesListParams = {}) {
  return useQuery({
    ...config,
    queryKey: audienceChannelSourcesQueryKeys.list(params),
    queryFn: () => getAudienceChannelSourcesList(params),
  });
}
